import { DocumentationLegacyPageBlockText } from "../../model/documentation/blocks/SDKDocumentationLegacyPageBlockText";
import { DocumentationLegacyGroupBehavior } from "../../model/enums/SDKDocumentationLegacyGroupBehavior";
import { DocumentationLegacyPageBlockType } from "../../model/enums/SDKDocumentationLegacyPageBlockType";
import Fuse from "fuse.js";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var DocSearchResultDataType;
(function (DocSearchResultDataType) {
    DocSearchResultDataType["contentBlock"] = "contentBlock";
    DocSearchResultDataType["sectionHeader"] = "sectionHeader";
    DocSearchResultDataType["pageTitle"] = "pageTitle";
})(DocSearchResultDataType || (DocSearchResultDataType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Search Instance
/** Search manager */
export class DocSearch {
    // --- Constructor
    constructor(configuration) {
        // --- Search index
        /* Removes previous data from search index and creates new one */
        this.updateSearchIndex = (pages) => {
            let id = 0;
            const data = [];
            // Process every page for data
            pages.forEach((page) => {
                // Naming - For tabs, use name of the containing group, otherwise we get lot of design/code which is not very useful
                let pageName = page.title;
                if (page.parent &&
                    page.parent.groupBehavior === DocumentationLegacyGroupBehavior.tabs) {
                    pageName = `${page.parent.title}/${pageName}`;
                }
                // Extract rich text from headers and any text piece there is
                const allBlocks = this.flattenedBlocksOfPage(page);
                allBlocks.forEach((block) => {
                    if (block instanceof DocumentationLegacyPageBlockText) {
                        data.push({
                            id,
                            text: block.text.spans.map((s) => s.text).join(""),
                            type: block.type === DocumentationLegacyPageBlockType.heading
                                ? DocSearchResultDataType.sectionHeader
                                : DocSearchResultDataType.contentBlock,
                            blockId: block.id,
                            pageId: page.id,
                            pageName,
                        });
                        id += 1;
                    }
                });
                // Push page information
                data.push({
                    id,
                    text: page.title,
                    type: DocSearchResultDataType.pageTitle,
                    blockId: undefined,
                    pageId: page.id,
                    pageName,
                });
                id += 1;
            });
            this.searchEngine = this.reconstructSearchIndex(data, this.searchConfiguration);
            return data;
        };
        /* Removes previous data from search index and creates new one */
        this.search = (input) => {
            return this.searchEngine.search(input);
        };
        /** Reconstructs the search index */
        this.reconstructSearchIndex = (data, options) => {
            const fuse = new Fuse(data, options);
            return fuse;
        };
        /** Creates flattened structure of the blocks, even from the contained blocks, so it is easier to iterate through them */
        this.flattenedBlocksOfPage = (page) => {
            let { blocks } = page;
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            page.blocks.forEach((block) => {
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                blocks = blocks.concat(this.flattenedBlocksOfBlock(block));
            });
            // @ts-expect-error TS(2322): Type 'DocumentationLegacyPageBlock[] | undefined' ... Remove this comment to see the full error message
            return blocks;
        };
        /** Flattens one leaf of blocks */
        this.flattenedBlocksOfBlock = (block) => {
            // @ts-expect-error TS(2322): Type 'DocumentationLegacyPageBlock[] | undefined' ... Remove this comment to see the full error message
            let subblocks = block.children;
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            block.children.forEach((subblock) => {
                subblocks = subblocks.concat(this.flattenedBlocksOfBlock(subblock));
            });
            return subblocks;
        };
        this.searchConfiguration = configuration;
        this.searchEngine = this.reconstructSearchIndex([], configuration);
    }
    // --- Conveniences
    /** When using this configuration, the results will be very precise and will not be deviating too much from the query */
    static defaultPreciseConfiguration() {
        return {
            shouldSort: true,
            threshold: 0.1,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            ignoreLocation: true,
            keys: ["text"],
        };
    }
    /** When using this configuration, the results will be more fuzzy and might cover broader spectrum results than just near-keyword based search */
    static defaultFuzzyConfiguration() {
        return {
            shouldSort: true,
            threshold: 0.2,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            ignoreLocation: true,
            keys: ["text"],
        };
    }
}
